exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button{color:aqua;display:inline-block;position:relative;padding:2px 5px}.button__badge{background-color:#fa3e3e;border-radius:50%;color:white;padding:1px 3px;font-size:10px;position:absolute;top:0;right:0}.not-seen-msg{font-weight:bold}.inbox_people{height:100%}\n", ""]);

// exports
